var render = function render(){var _vm=this,_c=_vm._self._c;return _c('instForm',{staticClass:"isntMainWrap"})
}
var staticRenderFns = []

export { render, staticRenderFns }